<template>
    <v-layout fill-height row justify-center>
        <v-flex sm12 md12 lg10 xl8 p-0>
            <v-card
                flat
                class="tariffs-card fill-height printable pa-0 ma-0"
            >
                <v-card-title class="pb-0">
                    <h2>{{ $t("subscriptionPlans.title") }}</h2>
                </v-card-title>

                <v-card-text>
                    <v-layout align-center justify-center>
                        <v-btn
                            class="mb-2"
                            color="success"
                            @click="showRegistration"
                        >{{ $t("tryForFree") }}</v-btn>
                    </v-layout>

                    <tariffs-table class="pa-0, ma-0"/>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import TariffsTable from "./TariffsTable";

    export default {
        name: "TariffsInfo",

        components: {
            TariffsTable
        },

        methods: {
            showRegistration () {
                this.$emit("showRegistration", true);
            }
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 128px)

    .tariffs-card
        overflow-y: auto
        max-height: calc(100dvh - 84px)

    .v-btn-toggle .v-btn
        min-width: 95px

    .v-btn__content
        color: black

    .period-button
        margin: 12px
        border-radius: 24px

    .period-button-left-element
        border-radius: 24px 0 0 24px !important

    .period-button-right-element
        border-radius: 0 24px 24px 0 !important

    .table
        margin-top: 16px
        margin-bottom: 8px
        height: 100%
        width: 100%
        min-width: 1000px
        text-align: center
        border-spacing: 0
        border: 1px solid #c4c1c1
        border-right: 0
        border-top: 0
        td, th
            padding: 2px
            height: 25px
            border: 1px solid #c4c1c1
            border-bottom: 0
            border-left: 0
        thead
            tr
                font-weight: bold
                background: #f9f9f9
                th:nth-child(n+2)
                    width: 140px
                &:first-child
                    height: 40px
            tr:nth-child(n+2)
                height: 35px
                th
                    font-weight: normal
                th:first-child
                    text-align: right
                    padding-right: 12px

        tbody
            tr.subheader
                height: 40px
                background: #dbefdd
                font-weight: bold
</style>